import Dexie, { Table } from "dexie";
import { UUID } from "angular2-uuid";
import { StoredCapturedBinaryDataFragment } from "../driver/storage/models/stored-captured-binary-data-fragment";
import { StoredFileCaptureConfiguration } from "../driver/storage/models/stored-file-capture-configuration";
import { StoredDispatchedServiceSyncData } from "../driver/storage/models/stored-dispatched-service-sync-data";
import { StoredPhysicalAddressGeoLocation } from "../maps/storage/models/stored-physical-address-geolocation";
import { StoredGpsPoint } from "../driver/storage/models/stored-gps-point";
import { DatabaseUpgradeManager } from "./versions/upgrade-manager/database-upgrade-manager";
import { VersionRegistry } from "./versions/registry/version-registry";
import { StoredDocument } from "../driver/storage/models/stored-document";
import { StoredCachedService } from "../driver/storage/models/stored-cached-service";
import { StoredStateData } from "../driver/storage/models/stored-state-data";

/**
 * Creates the IndexedDB database and tables.
 */
export class IndexedDBDataStore extends Dexie {
	/**
	 * The table for storing the default routing depot address.
	 */
	public DefaultRoutingDepotAddresses!: Table<StoredPhysicalAddressGeoLocation, UUID>;

	/**
	 * The table for storing the capture binary data fragments from the photo capture and OS&D service actions.
	 */
	public CapturedBinaryDataFragments!: Table<StoredCapturedBinaryDataFragment, UUID>;

	/**
	 * The table for storing dispatched service sync data.
	 */
	public DispatchedServiceSyncData!: Table<StoredDispatchedServiceSyncData, UUID>

	/**
	 * The table for storing dispatched service documents.
	 */
	public DispatchedServiceDocuments!: Table<StoredDocument, UUID>

	/**
	 * The table for storing driver GPS points.
	 */
	public GpsPoints!: Table<StoredGpsPoint, UUID>

	/**
	 * The table for storing file capture configurations.
	 */
	public FileCaptureConfiguration!: Table<StoredFileCaptureConfiguration, UUID>

	/**
	 * The table for storing service cached data.
	 */
	public CachedServices!: Table<StoredCachedService, UUID>;

	/**
	 * The table for storing state data for dispatched services.
	 */
	public StateData!: Table<StoredStateData, UUID>;

	/**
	 * @constructor
	 */
	constructor() {
		super("CrownX");
		DatabaseUpgradeManager.ApplyUpgrades(this, VersionRegistry.Upgrades);
	}
}

/**
 * The instance of IndexedDB with the created database and tables.
 */
export const indexedDb = new IndexedDBDataStore();
indexedDb.version(VersionRegistry.LatestVersionNumber());